export default __webpack_public_path__ + "static/media/five_.d352240f.jpeg";